import React, { Component } from 'react';
import Rating from 'react-rating';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import { errorHandler, getContent, getErrorMessage, getServerTime } from '../../util/responseUtil';
import { targetResolutionTime, targetResponseTime, timeFrom, timeFromNow } from '../../util/date';
import { STATUS_TICKET_CONSTANT } from '../../constants/statusTicketConstant';
import { ROLE_CATEGORY_CONSTANT } from '../../constants/roleCategoryConstant';
import { ROUTER_CONSTANT } from '../../constants/routerConstant';
import API_TICKET_LIST from '../../api/apiTicketList';
import API_NOTIFICATION from '../../api/apiNotification';
import Alert from '../Alert/Alert';
import IconStarEmpty from '../../assets/icons/IconStarEmpty';
import IconStarFull from '../../assets/icons/IconStarFull';
import { MESSAGE_STATUS_CONSTANT } from '../../constants/messageStatusConstant';
import { MESSAGE_TYPE_CONSTANT } from '../../constants/messageTypeConstant';
import { CheckPermissionApi } from '../../util/permission';
import { TICKET_LIST_ALL_CHAT_INSERT_ASSIGNEE } from '../../constants/menuPermissionConstant';

class TicketCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customerServiceId: 0,
            ticket: {},
            serverTime: '',
            currentServerTime: '',
            intervalGrabTicketTimeout: 0,
            defaultMessageRoomChat: '',
            showConfirmAlertGrabTicket: false,
            showConfirmAlertOpenTicket: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
        this.ticketRef = React.createRef();
    }

    getServerTime = () => {
        API_NOTIFICATION.getServerTime(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let serverTime = new Date(getContent(res));
                    let currentDate = new Date().getTime();

                    this.realServerTime = setInterval(() => {
                        let endDate = new Date().getTime();
                        let diff = endDate - currentDate;
                        let result = serverTime.getTime() + diff;

                        this.setState({
                            serverTime: result,
                            currentServerTime: getServerTime(res)
                        })
                    }, 1000);
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getParameterGrabTicketTimeout = () => {
        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_NEW) && this.props.userDetail.level === ROLE_CATEGORY_CONSTANT.CSO) {
            API_TICKET_LIST.getParameterGrabTicketTimeout(this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            intervalGrabTicketTimeout: getContent(res)
                        })
                    }
                }).catch(errorHandler(this.props.handleLogout, this.props.history))
        }
    }

    getDefaultMessageRoomChat = () => {
        return API_TICKET_LIST.getDefaultMessageRoomChat(1, 100, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        defaultMessageRoomChat: getContent(res)[0].description
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    handleAssignOwn = ticket => {
        this.setState({ ticket, showConfirmAlertGrabTicket: true });
    }

    handleGrabTicket = () => {
        const updatedAt = {
            updated_at: this.state.ticket.updated_at
        }

        API_TICKET_LIST.putDataAssignOwn(updatedAt, this.state.ticket.id, this.props.token)
            .then(async res => {
                await this.handleOpenRoomChat(getContent(res));
                await this.handleSetOpenRoomChatId(this.state.ticket.id);
                this.props.history.push(`${ROUTER_CONSTANT.TICKET_DETAIL_ALL.split(':')[0]}${this.state.ticket.id}`);
            }).catch(err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true,
                    showConfirmAlertGrabTicket: false
                });
            })
    }

    handleOpenDetail = ticket => {
        // Lihat Detail CSO Tiket Status Assigned
        if (ticket.status === STATUS_TICKET_CONSTANT.ASSIGNED && this.props.userDetail.level === ROLE_CATEGORY_CONSTANT.CSO) {
            return this.setState({ ticket, showConfirmAlertOpenTicket: true });
        }
        // Lihat Detail CSO Tiket Status In Progress (Tiket Hasil Eskalasi)
        if (ticket.status === STATUS_TICKET_CONSTANT.IN_PROGRESS && this.props.userDetail.level === ROLE_CATEGORY_CONSTANT.CSO && ticket.chatroom_id === '') {
            return this.setState({ ticket }, async () => {
                await this.getDefaultMessageRoomChat();
                const message = this.state.defaultMessageRoomChat.replace('%NamaCS', `${this.props.userDetail.first_name} ${this.props.userDetail.last_name}`);
                await this.handleOpenRoomChat(message);
                await this.handleSetOpenRoomChatId(ticket.id);
                this.redirectPage(ticket.id);
                localStorage.setItem('ticketId', ticket.id);
            });
        }
        this.redirectPage(ticket.id);
        localStorage.setItem('ticketId', ticket.id);
    }

    handleOpenTicket = () => {
        const updatedAt = {
            updated_at: this.state.ticket.updated_at
        }

        API_TICKET_LIST.putDataOpenTicket(updatedAt, this.state.ticket.id, this.props.token)
            .then(async res => {
                await this.handleOpenRoomChat(getContent(res));
                await this.handleSetOpenRoomChatId(this.state.ticket.id);
                this.redirectPage(this.state.ticket.id);
            }).catch(err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true,
                    showConfirmAlertOpenTicket: false
                });
            })
    }

    handleSetOpenRoomChatId = id => {
        if (CheckPermissionApi(TICKET_LIST_ALL_CHAT_INSERT_ASSIGNEE, this.props.userDetail.permissions)) {
            const roomId = `${this.props.userDetail.client_id}_${this.state.ticket.ticket_no}_${this.state.ticket.pic_client_id}`;
            const data = {
                updated_at: '',
                chatroom_id: this.state.ticket.pic_client_id ? roomId : ''
            }
            return API_TICKET_LIST.putOpenChatroom(data, id, this.props.token)
        }
        return;
    }

    handleOpenRoomChat = message => {
        const roomId = `${this.props.userDetail.client_id}_${this.state.ticket.ticket_no}_${this.state.ticket.pic_client_id}`;
        const payload = {
            type: 'chat',
            message: {
                is_group: false,
                source_id: this.props.userDetail.client_id,
                destination_id: this.state.ticket.pic_client_id,
                identity: {
                    client_id: this.props.userDetail.client_id,
                    sign: this.props.sign
                },
                message_detail: {
                    guarantee: true,
                    type: MESSAGE_STATUS_CONSTANT.SEND,
                    message_id: uuidv4(),
                    message_model: {
                        additional_key: '',
                        content: {
                            text: message
                        },
                        created_at: moment().tz("Asia/Jakarta").valueOf(),
                        deleted_type: 0,
                        is_broadcast: 0,
                        is_encrypted: 'N',
                        is_forward: 0,
                        local_id: 'local_id',
                        message_reply_id: '',
                        room_id: roomId,
                        type_message_id: MESSAGE_TYPE_CONSTANT.TEXT,
                        vector_x: 1,
                        vector_y: 0
                    }
                }
            }
        }

        const websocket = this.props.websocket;
        if (this.state.ticket.pic_client_id) localStorage.setItem('openRoomChat', 'true');
        return websocket.send(JSON.stringify(payload));
    }

    handleDisableButtonGrabTicket = ticket => {
        let createdAt = Date.parse(ticket.created_at);
        let interval = this.state.intervalGrabTicketTimeout * 1000;
        let now = Date.parse(moment.utc(this.state.serverTime));

        let isDisabled = true;
        // Jika waktu dibuat + timeout < waktu sekarang
        if (createdAt + interval < now) {
            isDisabled = false;
        }
        // Timeout untuk grab ticket
        let delay = createdAt + interval - now;
        if (delay < 0) {
            isDisabled = false;
        } else {
            setTimeout(() => isDisabled = false, delay);
        }
        return (
            <button type="button" className={`${isDisabled ? 'bg-gray-300 text-gray-400 cursor-not-allowed' : 'bg-lightblue text-white'} flex justify-center items-center text-center text-sm rounded-md capitalize w-24 py-2 mr-3`} id="btnassignown" onClick={() => this.handleAssignOwn(ticket)} disabled={isDisabled}>
                Ambil Tiket
            </button>
        )
    }

    handleErrorAlert = () => {
        this.setState({ showErrorAlertResponse: false });
        if (this.props.refresh !== undefined) {
            this.props.refresh();
        }
    }

    redirectPage = id => {
        window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_NEW) && this.props.history.push(`${ROUTER_CONSTANT.TICKET_DETAIL_NEW.split(':')[0]}${id}`);
        window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_ALL) && this.props.history.push(`${ROUTER_CONSTANT.TICKET_DETAIL_ALL.split(':')[0]}${id}`);
        window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_MEMBER) && this.props.history.push(`${ROUTER_CONSTANT.TICKET_DETAIL_MEMBER.split(':')[0]}${id}`);
        window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_SOLUTION) && this.props.history.push(`${ROUTER_CONSTANT.TICKET_DETAIL_SOLUTION.split(':')[0]}${id}`);
    }

    statusTicket = status => {
        if (status === STATUS_TICKET_CONSTANT.UNASSIGNED) return 'Unassigned';
        if (status === STATUS_TICKET_CONSTANT.ASSIGNED) return 'Assigned';
        if (status === STATUS_TICKET_CONSTANT.IN_PROGRESS) return 'In-Progress';
        if (status === STATUS_TICKET_CONSTANT.ON_HOLD) return 'On-Hold';
        if (status === STATUS_TICKET_CONSTANT.RESOLVED) return 'Resolved';
        if (status === STATUS_TICKET_CONSTANT.CLOSED) return 'Closed';
        if (status === STATUS_TICKET_CONSTANT.UNDER_OBSERVATION) return 'Under Observation';
    }

    scollTicket = () => {
        const ticketId = localStorage.getItem('ticketId');;
        if (ticketId) {
            const element = document.getElementById(ticketId);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }

    handleScrollTicket = async () => {
        await this.scollTicket();
        localStorage.removeItem('ticketId');
    }

    componentDidMount() {
        this._isMounted = true;

        this.getServerTime();
        this.getParameterGrabTicketTimeout();
        this.handleScrollTicket();
    }

    componentWillUnmount() {
        this._isMounted = false;
        clearInterval(this.realServerTime)
    }

    render() {
        return (
            <div className="h-full px-1">
                {
                    this.props.ticketList.map(ticket =>
                        <div className="flex justify-between bg-white rounded shadow-box-button px-5 py-3 mb-3" key={ticket.id} id={ticket.id} ref={this.ticketRef}>
                            <div className="flex items-center">
                                {
                                    ticket.status === STATUS_TICKET_CONSTANT.UNASSIGNED && this.props.userDetail.level === ROLE_CATEGORY_CONSTANT.CSO
                                        ? this.handleDisableButtonGrabTicket(ticket)
                                        : <div>
                                            <div className={ticket.status + " flex justify-center items-center text-center text-white text-sm rounded-md w-24 py-2 mr-3"}>
                                                {this.statusTicket(ticket.status)}
                                            </div>
                                        </div>
                                }
                                <div className="text-gray-600">
                                    <div className="flex items-center">
                                        <span className="mr-2">{ticket.principal} | {ticket.ticket_no} | {ticket.percentage}% {ticket.assign_type !== '' && ' | ' + ticket.assign_type}</span>
                                        <div
                                            className={(this.props.userDetail.level === ROLE_CATEGORY_CONSTANT.CSO && window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_NEW)) ? "hidden" : "text-lightred cursor-pointer text-sm mx-2"}
                                            id="btndetailticket"
                                            onClick={() => this.handleOpenDetail(ticket)}
                                        >
                                            Lihat Detail
                                        </div>
                                    </div>
                                    <div className="flex items-center">
                                        <p className="font-bold cursor-pointer w-max max-w-xs truncate mr-3" id="btnopenside" onClick={() => this.props.openSide(ticket)} title={ticket.issue_title}>{ticket.issue_title}</p>
                                        <div className={ticket.status !== STATUS_TICKET_CONSTANT.RESOLVED && ticket.status !== STATUS_TICKET_CONSTANT.CLOSED && ticket.status !== STATUS_TICKET_CONSTANT.UNDER_OBSERVATION ? "hidden" : "flex items-center"}>
                                            <Rating
                                                initialRating={ticket.rate}
                                                emptySymbol={<IconStarEmpty />}
                                                fullSymbol={<IconStarFull />}
                                                readonly
                                            />
                                            {ticket.rate === 0 ? <p className="text-xs text-gray-400 ml-3">Belum ada ulasan</p> : <p className="text-xs font-bold ml-3">{ticket.rate}/5</p>}
                                        </div>
                                    </div>
                                    <p className="text-sm my-0.5"><span className="capitalize">{ticket.customer} | {ticket.tracker}</span> | Waktu dibuat {moment.utc(ticket.created_at).format('DD/MM/YYYY HH:mm')}</p>
                                    <div className="flex text-sm my-0.5">
                                        <p className="truncate mr-1">PIC {ticket.pic_name}</p>
                                        <p className="truncate">{ticket.status !== STATUS_TICKET_CONSTANT.UNASSIGNED && ' | CS ' + ticket.cs} | Operator {ticket.tracker === 'grochat' ? 'NexCare Mobile - ' + ticket.operator_name : ticket.operator_name}</p>
                                    </div>
                                    <p className="text-sm my-0.5">
                                        {
                                            ticket.status !== STATUS_TICKET_CONSTANT.RESOLVED && ticket.status !== STATUS_TICKET_CONSTANT.CLOSED && ticket.status !== STATUS_TICKET_CONSTANT.UNDER_OBSERVATION
                                                ? `Waktu diperbaharui ${moment.utc(ticket.updated_at).format('DD/MM/YYYY HH:mm')}` : ''
                                        }
                                        {
                                            ticket.status !== STATUS_TICKET_CONSTANT.RESOLVED && ticket.status !== STATUS_TICKET_CONSTANT.CLOSED && ticket.status !== STATUS_TICKET_CONSTANT.UNDER_OBSERVATION
                                                ? ticket.status === STATUS_TICKET_CONSTANT.ASSIGNED
                                                    ? targetResponseTime(ticket.response_time_left.target)
                                                    : timeFromNow(ticket.open_at, this.state.currentServerTime) !== '' ? ' | Direspon dalam ' + timeFrom(ticket.created_at, ticket.open_at) : ''
                                                : `Waktu respon ${moment.utc(ticket.open_at).format('DD/MM/YYYY HH:mm')}`
                                        }
                                        {
                                            ticket.status !== STATUS_TICKET_CONSTANT.RESOLVED && ticket.status !== STATUS_TICKET_CONSTANT.CLOSED && ticket.status !== STATUS_TICKET_CONSTANT.UNDER_OBSERVATION
                                                ? targetResolutionTime(ticket.resolution_time_left)
                                                : ' | Diselesaikan dalam ' + timeFrom(ticket.open_at, ticket.close_at)
                                        }
                                    </p>
                                </div>
                            </div>
                            <div className="flex flex-col justify-center items-end text-gray-700 max-w-md truncate text-sm">
                                <div className="flex items-center capitalize">{ticket.priority} <div className="rounded-full h-3 w-3 ml-1 mr-0.5" style={{ backgroundColor: ticket.color }}></div></div>
                                <select id={`ddlcomplaint-${ticket.ticket_no}`} className="outline-none custom-select my-1" disabled><option>{ticket.complaint}</option></select>
                                <select id={`ddlcomplaintcategory-${ticket.ticket_no}`} className="outline-none custom-select my-1" disabled><option>{ticket.complaint_category}</option></select>
                                <select id={`ddlcomplaintsub-${ticket.ticket_no}`} className="outline-none custom-select my-1 w-full truncate" title={ticket.complaint_sub} disabled><option>{ticket.complaint_sub}</option></select>
                            </div>
                        </div>
                    )
                }
                <Alert show={this.state.showConfirmAlertGrabTicket} icon="warning" button={true} title="Apakah Anda yakin mau mengambil tiket ini?" close={() => this.setState({ showConfirmAlertGrabTicket: false })} submit={() => this.handleGrabTicket()} />
                <Alert show={this.state.showConfirmAlertOpenTicket} icon="warning" button={true} title="Apakah Anda yakin mau mengerjakan tiket ini?" close={() => this.setState({ showConfirmAlertOpenTicket: false })} submit={() => this.handleOpenTicket()} />
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title="Oops, Gagal" desc={this.state.errorMessage} close={() => this.handleErrorAlert()} ok />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail,
        sign: state.authentication.sign,
        websocket: state.grochatWebsocket.websocket
    };
};

export default withRouter(connect(mapStateToProps, null)(TicketCard));